import NotificationItem from "./notification-item.component";

export default NotificationItem;
